import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { eur } from "@/lib/api";
import { Minus, Plus, Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CartDrawer() {
  const { items, remove, setQty, total, open, setOpen } = useCart();
  const navigate = useNavigate();

  const checkout = () => {
    setOpen(false);
    navigate("/checkout");
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-drawer" className="bg-bone border-l border-ink/10 w-full sm:max-w-md flex flex-col">
        <SheetHeader>
          <SheetTitle className="font-serif-display text-3xl text-left">Il tuo carrello</SheetTitle>
        </SheetHeader>

        {items.length === 0 ? (
          <div className="flex-1 flex items-center justify-center text-ink-soft">Il carrello è vuoto.</div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto py-6 space-y-6">
              {items.map((i) => (
                <div key={i.id} data-testid={`cart-item-${i.id}`} className="flex gap-4">
                  <div className="w-20 h-24 bg-linen overflow-hidden flex-shrink-0">
                    <img src={i.image} alt={i.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="flex-1">
                    <p className="font-serif-display text-lg leading-tight">{i.name}</p>
                    <p className="text-xs uppercase tracking-wide text-ink-soft">{i.producer}</p>
                    {i.stock > 0 && i.stock <= 5 && (
                      <p data-testid={`cart-urgency-${i.id}`} className="text-[11px] uppercase tracking-[0.08em] text-claret font-600 mt-1">{i.stock === 1 ? "Ultima rimasta — affrettati!" : `Solo ${i.stock} rimaste — affrettati!`}</p>
                    )}
                    <div className="mt-2 flex items-center justify-between">
                      <div className="flex items-center border border-ink/20">
                        <button data-testid={`decr-${i.id}`} onClick={() => setQty(i.id, i.quantity - 1)} className="p-1.5 hover:bg-linen"><Minus size={14} /></button>
                        <span className="px-3 text-sm">{i.quantity}</span>
                        <button data-testid={`incr-${i.id}`} onClick={() => setQty(i.id, i.quantity + 1)} className="p-1.5 hover:bg-linen"><Plus size={14} /></button>
                      </div>
                      <span className="text-sm">{eur(i.price * i.quantity)}</span>
                    </div>
                  </div>
                  <button data-testid={`remove-${i.id}`} onClick={() => remove(i.id)} className="text-ink-soft hover:text-claret self-start transition-colors"><Trash2 size={16} /></button>
                </div>
              ))}
            </div>

            <div className="border-t border-ink/10 pt-6 space-y-4">
              <div className="flex justify-between text-lg">
                <span className="font-serif-display">Totale</span>
                <span data-testid="cart-total" className="font-medium">{eur(total)}</span>
              </div>
              <button
                data-testid="checkout-btn"
                onClick={checkout}
                className="w-full bg-claret hover:bg-claret-dark text-bone py-4 uppercase tracking-[0.15em] text-sm transition-colors"
              >
                Procedi con l'ordine
              </button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
